import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import useFetchWrapper, { HttpResponse } from "../../Helpers/useFetchWrapper";
import useObjectHelper from "../../Helpers/useObjectHelper";
import { FeedbackTypes } from "../CreateFeedback/CreateFeedback.model";
import { CreateVideoFeedbackRequest } from "./CreateVideoFeedback.model";

export const useCreateVideoFeedback = () => {
	const [step, setStep] = useState<1 | 2 | 3>(1);
	const [topics, setTopics] = useState<string[]>([]);
	const [rating, setRating] = useState<number>(0);

	const { get, postFormData } = useFetchWrapper();

	const { objToFormData } = useObjectHelper();


	const { control, formState: { errors }, handleSubmit, } = useForm({
		defaultValues: {
			description: ''
		}
	})

	const getTopics = async() => {
		const response: HttpResponse<string[]> = await get('/review/feedback-topic');
		if(response.parsedBody){
			setTopics(response.parsedBody);
		}
	}

	const submitFeedback = async (data: any) => {
		const formData: CreateVideoFeedbackRequest = {
			description: data.description,
			feedbackType: FeedbackTypes.VideoFeedback,
			shortDescription: rating.toString(),
			topics: topics[0]
		}
		const response = await postFormData('/review/feedback', objToFormData(formData));
		if (response.status === 200) {
			setStep(3);
		}
	}
	useEffect(() => {
		getTopics();
	},[])

	return {
		control,
		handleSubmit,
		setRating,
		setStep,
		state: {
			rating,
			step
		},
		submitFeedback
	}

}